export default "__VITE_ASSET__DfRnfTU8__"